export const convertToSentenceCase = (str = '') => {
  let replacedString = str?.replace(/_/g, ' ')?.toLowerCase();
  return replacedString?.charAt(0)?.toUpperCase() + replacedString?.slice(1);
};

export const pluralize = (
  number,
  singularStr: string = '',
  pluralStr?: string,
) => {
  if (typeof singularStr !== 'string' || typeof number !== 'number') return '';
  return number > 1 ? pluralStr || singularStr + 's' : singularStr;
};

export const sanitizeString = (str = '') => {
  return str
    ?.trim()
    ?.toLowerCase()
    ?.replace(/[_\-\s]/g, '');
};

export const camelToPascal = (str) => {
  let updatedStr = str.charAt(0).toUpperCase() + str.slice(1);
  updatedStr = updatedStr.replace(/([A-Z])/g, ' $1').trim();
  return updatedStr;
};

export function toTitleCase(str: string): string {
  return str
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(' ');
}

export function replaceAll(
  str: string,
  search: string,
  replacement: string,
): string {
  if (!replacement) {
    replacement = '';
  }
  return str.split(search).join(replacement);
}

export function isString(value) {
  return typeof value === 'string';
}

export function formatCommaSeparatedString(value: string) {
  if (!value) return '';

  return value
    ?.trim()
    ?.split(',')
    ?.map((ele) => ele.trim())
    ?.join(',');
}

export function capitalizeFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
